// Template189: Bangkok - Gran Palacio (Día 1)
// Idéntico a PageGranPalacio.jsx de guia-bangkok; todos los textos e imágenes vienen de page (backend).

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template189 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[5]?.content;
	const block2Body = page?.texts?.[6]?.content;
	const consejoText = page?.texts?.[7]?.content;
	const tipText = page?.texts?.[8]?.content;
	const llegarTitle = page?.texts?.[9]?.content;
	const llegarContent = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const palacioImage = getImageSrc("palacio");
	const budaImage = getImageSrc("buda");
	const portadaSticker = getCanvasImageUrl("portada-sticker");
	const sticker2 = getCanvasImageUrl("sticker2");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const sabiasQueLlegar = Array.isArray(page?.data?.sabiasQueLlegar)
		? page.data.sabiasQueLlegar
		: [];

	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#000",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			{/* CABECERA */}
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* IMAGEN PORTADA */}
			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: isSmallScreen ? 28 : 32,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 60, left: 18 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
					marginTop: "-10px",
				}}
			>
				{intro && (
					<Box sx={{ fontSize: 13, color: "#333", margin: 0, padding: 0 }}>
						{intro}
					</Box>
				)}

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					{/* BLOQUE 1: Gran Palacio */}
					<Box data-block-id="text-2" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{palacioImage && (
							<Box
								component="img"
								src={palacioImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue.length > 0 && (
							<>
								<Box sx={{ position: "absolute", top: -10, left: "32%" }}>
									<SabiasQue
										icono={sabiasQue[0]?.icono ?? "👗"}
										texto={sabiasQue[0]?.texto ?? ""}
									/>
								</Box>
								{sabiasQue[1] && (
									<Box sx={{ position: "absolute", top: 32, left: "32%" }}>
										<SabiasQue
											icono={sabiasQue[1]?.icono ?? "⏰"}
											texto={sabiasQue[1]?.texto ?? ""}
										/>
									</Box>
								)}
							</>
						)}
						<Box sx={{ width: "60%" }}>
							<Box component="h3" sx={estiloH3}>
								{block1Title}
							</Box>
							{block1Body && (
								<Box component="p" sx={estiloP}>
									{block1Body}
								</Box>
							)}
						</Box>
					</Box>

					{/* BLOQUE 2: Wat Phra Kaew / Buda */}
					<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
						<Box sx={{ width: "100%" }}>
							<Box
								component="p"
								sx={{
									...estiloP,
									padding: 1.5,
									backgroundColor: "#FFF3CD",
									borderRadius: "12px",
								}}
							>
								{budaImage && (
									<Box
										component="img"
										src={budaImage}
										alt=""
										sx={{
											width: 105,
											float: "right",
											marginRight: -2.5,
											marginTop: -2.5,
										}}
									/>
								)}
								<Box component="h3" sx={estiloH3}>
									{block2Title}
								</Box>
								{block2Body}
							</Box>
						</Box>
					</Box>

					{/* CONSEJO */}
					{consejoText && (
						<Box
							data-block-id="text-4"
							sx={{
								backgroundColor: "#d4edda",
								border: "3px solid #28a745",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 13,
								color: "#333",
							}}
						>
							<Box component="p" sx={{ ...estiloP, margin: 0 }}>
								{consejoText}
							</Box>
						</Box>
					)}

					{/* TIP BOX (absolute) */}
					{tipText && (
						<Box
							data-block-id="text-5"
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? 150 : 100,
								right: 35,
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: 11,
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: isSmallScreen ? 240 : 340,
								zIndex: 3,
							}}
						>
							{tipText}
						</Box>
					)}

					{sticker2 && (
						<Box
							component="img"
							src={sticker2}
							alt=""
							sx={{
								width: 100,
								position: "absolute",
								bottom: isSmallScreen ? 100 : 50,
								right: -20,
								zIndex: 2,
							}}
						/>
					)}

					{/* Cómo llegar */}
					{(llegarTitle || llegarContent) && (
						<Box
							data-block-id="text-6"
							sx={{
								backgroundColor: "#FFF3CD",
								border: "3px solid #E8A838",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 13,
								color: "#333",
								marginBottom: isSmallScreen ? 1.5 : 0,
								width: "100%",
								marginTop: isSmallScreen ? 15 : 5,
								position: "relative",
							}}
						>
							{sabiasQueLlegar.length > 0 && (
								<>
									<Box
										sx={{
											position: "absolute",
											top: -30,
											left: isSmallScreen ? "30%" : "25%",
										}}
									>
										<SabiasQue
											icono={sabiasQueLlegar[0]?.icono ?? "💎"}
											texto={sabiasQueLlegar[0]?.texto ?? ""}
										/>
									</Box>
									{sabiasQueLlegar[1] && (
										<Box
											sx={{
												position: "absolute",
												top: -30,
												left: isSmallScreen ? "40%" : "17%",
											}}
										>
											<SabiasQue
												icono={sabiasQueLlegar[1]?.icono ?? "🛕"}
												texto={sabiasQueLlegar[1]?.texto ?? ""}
											/>
										</Box>
									)}
								</>
							)}
							{llegarTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: 1,
										fontSize: 13,
										fontWeight: 700,
										display: "flex",
										alignItems: "center",
										gap: 0.75,
										color: "#E8A838",
										textTransform: "uppercase",
									}}
								>
									{llegarTitle}
								</Box>
							)}
							{llegarContent && (
								<Box
									component="ul"
									sx={{ paddingLeft: 0, margin: 0, lineHeight: 1.5 }}
								>
									{llegarContent}
								</Box>
							)}
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template189.thumbnail = "/images/template-1.png";

export default Template189;
